import { jsx as _jsx } from "react/jsx-runtime";
import MuiCard from '@mui/material/Card';
export default function Card({ variant, padding = '16px', sx, ...props }) {
    switch (variant) {
        case 'outlined':
            return _jsx(MuiCard, { variant: "outlined", sx: { padding, ...sx }, ...props });
        case 'filled':
            return _jsx(MuiCard, { variant: "outlined", sx: { padding, boxShadow: '0 0 15px rgba(0, 0, 0, 0.1)', ...sx }, ...props });
        default:
            return _jsx(MuiCard, { variant: "elevation", sx: { padding }, ...props });
    }
}
